export const matchPaymentOrderConfig = {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '供应商',
                advanceLabel: '供应商',
                value: 'carrierName',
                advanceConfig: [
                    { prop: 'supplierNameCn', value: '供应商名称' },
                    { prop: 'supplierCode', value: '供应商编码' }
                ],
                tableConfig: [
                    { prop: 'supplierNameCn', value: '供应商名称' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'transNameListStr', value: '采购渠道' }
                ],
                method: 'post',
                prefix: '/api-tms',
                advanceUrl: '/srm/supplier/search',
                type: 'advance',
                advanceNotSearch: true,
                queryConditionRequired: true,
                cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode'],
                advanceCascade: 'supplierCode#carrierCode',
                unfold: true,
                span: 5
            },
            {
                name: '司机',
                type: 'advance',
                value: 'driver',
                multiple: true,
                border: true,
                dialogWidth: '800px',
                maxSelect: 5,
                multipleTableColumn: {
                    prop: 'name', 'value': '司机名称'
                },
                advanceConfig: [
                    { 'prop': 'name', 'value': '司机名称' },
                    { 'prop': 'encuMobile', 'value': '司机电话' }
                ],
                tableConfig: [
                    { 'prop': 'name', 'value': '司机名称' },
                    { 'prop': 'encuMobile', 'value': '司机电话' }
                ],
                advanceUrl: 'suDriver/searchByConditions',
                cbParams: [
                    'name#driver', 'encuMobile#driverContactWay'
                ],
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        height: 400,
        leftWidth: 120,
        selectBtn: true,
        leftOperation: false,
        columns: [
            {
                label: '供应商名称',
                width: 150,
                prop: 'carrierName',
                sort: true
            },
            {
                label: '供应商编码',
                width: 150,
                prop: 'carrierCode',
                sort: true
            },
            {
                label: '司机名称',
                prop: 'driver',
                width: 150,
                sort: true
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                width: 150,
                sort: true
            },
            {
                label: '司机电话',
                prop: 'driverContactWay',
                width: 150,
                sort: true
            },
            {
                label: '发车时间',
                width: 150,
                prop: 'dispatchTime',
                sort: true
            },
            {
                label: '始发地址',
                width: 150,
                prop: 'startAddress',
                sort: true
            },
            {
                label: '目的地址',
                width: 150,
                prop: 'endAddress',
                sort: true
            }
        ],
        action: []
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: []
};

export const payOrderDetailConfig = {
    height: 350,
    leftWidth: 80,
    columns: [
        {
            label: '序号',
            prop: 'tableIndex',
            width: 60
        },
        {
            label: '司机名称',
            prop: 'driver',
            width: 100
        },
        {
            label: '支付对象',
            prop: 'payObject',
            type: 'select',
            optionNum: 'PAY_OBJECT',
            options: [],
            width: 120
        },
        {
            label: '单量',
            prop: 'dispatchCount',
            width: 60
        },
        {
            label: '支付金额',
            prop: 'payAmount',
            width: 100
        },
        {
            label: '支付类型',
            prop: 'payeeAcctType',
            mustFill: true,
            require: true,
            type: 'select',
            optionNum: 'PAYEE_TYPE',
            options: [],
            width: 100
        },
        {
            label: '收款户名',
            align: 'center',
            prop: 'payeeName',
            type: 'customInput',
            errorMessage: '户名与司机姓名不一致，请确认是否正确',
            require: true,
            mustFill: true,
            width: 150
        },
        {
            label: '收款卡号',
            prop: 'bankAccount',
            type: 'customAdvance',
            advanceLabel: '收款卡号',
            errorMessage: '收款卡号不小于10位,请确认是否正确',
            advanceConfig: [
                { prop: 'bankAccountName', value: '银行账户名' },
                { prop: 'bankAccount', value: '银行账户号' }
            ],
            tableConfig: [
                { prop: 'bankAccountName', value: '银行账户名' },
                { prop: 'bankAccount', value: '银行账户号' }
            ],
            method: 'post',
            prefix: '/api-antms/query',
            paramType: true,
            advanceUrl: '/carrier/settlement/payeeBook',
            cbParams: ['bankAccountName', 'bankAccount'],
            mustFill: true,
            require: true,
            width: 180
        },
        {
            label: '开户行',
            prop: 'bankname',
            type: 'advance',
            advanceLabel: '开户行',
            advanceConfig: [
                { prop: 'bankname', value: '开户行名称' },
                { prop: 'banknumber', value: '开户行编码' }
            ],
            tableConfig: [
                { prop: 'bankname', value: '开户行' },
                { prop: 'banknumber', value: '开户行编码' }
            ],
            method: 'post',
            advanceUrl: 'efContactNumbers',
            cbParams: ['bankname', 'banknumber', 'province', 'city'],
            require: true,
            width: 180
        }
    ],
    action: []
};
